import React from 'react'
import './commanComponents.css'

export default function BlueHeading({text}) {
  return (
    <h5 className='blueHeading'>{text}</h5>
  )
}
